module.exports = __webpack_public_path__ + "f0f238513219243772cd27f60f62587f.svg";